import React, { useEffect, useState } from 'react'
import DataTable from '../common/DataTable/DataTable'
import './Learning.css';
import api from '../../services/api';
import { useNavigate } from 'react-router-dom';
import { usePermission } from '../../hooks/usePermissions';

const EditIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 20h9" />
        <path d="M16.5 3.5a2.12 2.12 0 1 1 3 3L7 19l-4 1 1-4Z" />
    </svg>
);

const TrashIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="3 6 5 6 21 6" />
        <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
        <path d="M10 11v6" />
        <path d="M14 11v6" />
        <path d="M9 6V4h6v2" />
    </svg>
);

const LearningModules = () => {

    const navigate = useNavigate();
    const [learningModules, setLearningModules] = useState([]);
    const {hasPermission} = usePermission()

    const handleDelete = (id) => {
        if (!window.confirm("Are you sure you want to delete this learning module?")) return;

        api.delete(`/learningmodule/${id}`)
            .then(() => {
                setLearningModules(prev => prev.filter(module => module.id !== id));
            })
            .catch((error) => {
                console.error("Error deleting learning module:", error);
            });
    };

    const learningModuleColumns = [
        { key: "id", label: "ID" },
        { key: "module_name", label: "Module " },
        { key: "chapter_name", label: "Chapter" },
        { key: "topicheading", label: "Topic Heading" },
        { key: "content", label: "Content" },
        {
            key: "actions",
            label: "Actions",
            render: (value, row) => (
                <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
                    {hasPermission("MODIFY_LEARNINGCONTENT") && (
                        <button
                            className="lm-icon-btn"
                            title="Edit"
                            onClick={() => navigate(`/learningmodule/add/${row.id}`)}
                        >
                            <EditIcon />
                        </button>
                    )}
                    {hasPermission("DELETE_LEARNINGCONTENT") && (
                        <button
                            className="lm-icon-btn delete"
                            title="Delete"
                            onClick={() => handleDelete(row.id)}
                        >
                            <TrashIcon />
                        </button>
                    )}
                </div>
            ),
        },
    ];

    useEffect(() => {
        api.get('/learningmodule')
            .then((response) => {
                setLearningModules(response.data);
            })
            .catch((error) => {
                console.error('Error fetching learning module data:', error);
            });
    }, []);

    return (
        <div className="lm-pageContainer">
            <div className="lm-header">
                <div className="lm-headerLeft">
                    <h1>Learning Content</h1>
                    <p>Manage chapters and topics for learning modules</p>
                </div>

                {hasPermission("CREATE_LEARNINGCONTENT") && (
                    <div className="lm-headerActions">
                        <button className="lm-btnAdd" onClick={() => navigate("/learningmodule/add")}>
                            + Add Content
                        </button>
                    </div>
                )}
            </div>

            <DataTable columns={learningModuleColumns} data={learningModules} />
        </div>
    )
}

export default LearningModules